module.exports = __webpack_public_path__ + "static/media/ottawa-21.5b86c297.jpg";